import { Setup } from "..";
import { Invite } from "../common/steps/invite/invite";
import { Madlib, MadlibStepContext } from "../common/steps/madlib/madlib";
import { Preview } from "../common/steps/preview/preview";
import { SpaceDetails } from "../common/steps/space-details/space-details";

export const JiraSetup = () => {
    return (
        <Setup<MadlibStepContext>
            screens={[
                {
                    type: "split",
                    screenId: "space-details",
                    LeftComponent: SpaceDetails,
                    RightComponent: Preview
                },
                {
                    type: "split",
                    screenId: "madlib-setup-prompt",
                    LeftComponent: Madlib,
                    RightComponent: Preview
                },
                {
                    type: "split",
                    screenId: "invite",
                    LeftComponent: Invite,
                    RightComponent: Preview
                }
            ]}
        />
    );
};
